import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Tooltip, Row, Col } from 'antd';
import cx from 'classnames';

import {
  isCorporateTASelector,
  isRecruiterCompanySelector,
} from 'redux/selectors/authenticationSelectors';
import WelcomeSectionWrapper from '../WelcomeSectionWrapper';
import { handleClientModalOpen } from 'redux/reducers/clientSlice';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';

import imgLogo from 'assets/img/logo-new.svg';
import imgGear from 'assets/img/gear.gif';
import imgGearSt from 'assets/img/gear.png';

import styles from './ShowArroundPage.module.less';

export enum ShowArroundSteps {
  ShowArround = 3,
}

export default function ShowArroundPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isRecruiterCompany = useAppSelector(isRecruiterCompanySelector);
  const isCorporateTA = useAppSelector(isCorporateTASelector);

  const handleCreateCustomer = () => {
    dispatch(handleClientModalOpen(true));
    navigate('/');
  };

  const handleCompanyProfileRedirect = () => {
    navigate('/company-profile');
  };

  const handleTakeTour = () => {
    navigate('/tour');
  };

  return (
    <div className={styles.contentWrapp}>
      <img className={styles.logo} src={imgLogo} alt="logo" />

      <WelcomeSectionWrapper completedStepsCount={ShowArroundSteps.ShowArround}>
        <div>
          <div className={styles.cardBox}>
            <Row gutter={40}>
              {isRecruiterCompany && (
                <Col xs={24} md={12}>
                  <div onClick={handleCreateCustomer} className={styles.card}>
                    <div className={styles.cardImage}>
                      <img src={imgGearSt} alt="gear" />
                    </div>

                    <div className={styles.cardText}>
                      Create your first customer
                    </div>
                  </div>
                </Col>
              )}

              {isCorporateTA && (
                <Col xs={24} md={12}>
                  <div
                    onClick={handleCompanyProfileRedirect}
                    className={styles.card}
                  >
                    <div className={styles.cardImage}>
                      <img src={imgGearSt} alt="gear" />
                    </div>

                    <div className={styles.cardText}>
                      Fill in your account information
                    </div>
                  </div>
                </Col>
              )}

              <Col xs={24} md={12}>
                <div onClick={handleTakeTour} className={styles.card}>
                  <div className={styles.cardImage}>
                    <img src={imgGear} alt="gear" />
                  </div>

                  <div className={styles.cardText}>
                    Take our Back-Office product tour
                  </div>

                  <div className={styles.cardTooltip}>
                    <Tooltip
                      overlayClassName="light-tooltip"
                      title="Our intuitive platform is packed with valuable features. We highly recommend our quick tour."
                      trigger="click"
                      placement="rightTop"
                    >
                      <span
                        className="icon icon-attention-filled"
                        onClick={(e) => e.stopPropagation()}
                      />
                    </Tooltip>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div className={styles.infoBox}>
            <div className={styles.infoText}>
              Don’t have time now? No worries.
              <br />
              You can access product tour in your Account Settings.
            </div>

            <Button
              className={cx('borderless-btn', styles.infoBtn)}
              onClick={handleCompanyProfileRedirect}
            >
              Skip
            </Button>
          </div>
        </div>
      </WelcomeSectionWrapper>
    </div>
  );
}
